const features = [
  {
    icon: "ri-shield-check-line",
    title: "Military-Grade Encryption",
    description:
      "AES-256 encryption protects every byte of data transmitted through our VPN, ensuring your online activity remains completely private and inaccessible to third parties.",
  },
  {
    icon: "ri-eye-off-line",
    title: "Zero-Log Privacy Policy",
    description:
      "We never store, monitor, or share your browsing data. Our strict zero-log policy guarantees complete anonymity — your digital life belongs only to you.",
  },
  {
    icon: "ri-flashlight-line",
    title: "Blazing Fast Performance",
    description:
      "Optimized network routing and smart server selection deliver maximum speed without compromising security. Experience the internet the way it was meant to be.",
  },
  {
    icon: "ri-device-recover-line",
    title: "Intelligent Device Cleaning",
    description:
      "Deep-scan algorithms identify hidden junk files, oversized caches, and redundant data that silently eat into your iPhone's storage and slow down its performance.",
  },
  {
    icon: "ri-battery-2-charge-line",
    title: "Battery & Memory Optimization",
    description:
      "Our Cleaner app monitors background processes and memory usage in real time, freeing up system resources so your device stays responsive all day long.",
  },
  {
    icon: "ri-user-settings-line",
    title: "Seamless iOS Integration",
    description:
      "Built natively for iOS, our apps integrate deeply with the operating system to deliver a smooth, intuitive experience that feels like a natural extension of your iPhone.",
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-28 bg-white">
      <div className="max-w-7xl mx-auto px-10">
        {/* Header */}
        <p className="text-xs uppercase tracking-widest text-gray-400 font-medium mb-4">
          &bull;&nbsp; Capabilities
        </p>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-4">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] leading-tight" style={{ fontFamily: "'Inter', sans-serif" }}>
            Enhanced Security
            <br />
            &amp; Performance
          </h2>
          <p className="text-gray-500 text-sm max-w-sm leading-relaxed">
            Every feature is engineered with precision to deliver a safer, faster, and more private iOS experience.
          </p>
        </div>

        {/* Feature grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-[#F7F7F7] rounded-2xl p-9 flex flex-col gap-4 transition-all duration-200 hover:bg-[#F0F0F0]"
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${feature.icon} text-[#1A1A1A] text-2xl`} />
              </div>
              <h3 className="text-lg font-bold text-[#1A1A1A]" style={{ fontFamily: "'Inter', sans-serif" }}>
                {feature.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
